module.exports = __webpack_public_path__ + "static/media/Kent Kitchen  (7) - Copy.6ace6a5c.JPG";